import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import GameLog from './game-log-model'
import {
  CreateGameLogAsync,
  DeleteGameLogAsync,
  LoadGameLogsAsync,
} from './gameLog-thunk'
const initialState: gameLogSliceState = {
  gameLog: [],
  selected_gameLog: '',
  is_loading_gameLog: false,
  is_creating_gameLog: false,
  is_deleting_gameLog: false,
}
export interface gameLogSliceState {
  gameLog: GameLog[]
  selected_gameLog?: string
  is_loading_gameLog: boolean
  is_creating_gameLog: boolean
  is_deleting_gameLog: boolean
}
export const gameLogSlice = createSlice({
  name: 'gameLog',
  initialState,
  reducers: {
    setSelectedgameLog: (state, action) => {
      state.selected_gameLog = action.payload
    },
    clearStategameLog: (state) => {
      state.gameLog = []
      state.is_loading_gameLog = false
      state.is_creating_gameLog = false
      state.is_deleting_gameLog = false
    },
    mergegameLog: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_gameLog = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.gameLog = merge(state.gameLog, payload) as any
        }
      }
    },

    add_gameLog: (state, action) => {
      if (action.payload) {
        state.gameLog = [...state.gameLog, action.payload]
      }
    },
    set_gameLog: (state, action) => {
      let { key, value, id } = action.payload
      state.gameLog = state.gameLog.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadGameLogsAsync.pending, (state) => {
      state.is_loading_gameLog = true
    })
    builder.addCase(LoadGameLogsAsync.fulfilled, (state, action) => {
      state.is_loading_gameLog = false
      if (action.payload) {
        state.gameLog = action.payload
      }
    })
    builder.addCase(LoadGameLogsAsync.rejected, (state) => {
      state.is_loading_gameLog = false
    })
    builder.addCase(CreateGameLogAsync.pending, (state) => {
      state.is_creating_gameLog = true
    })
    builder.addCase(CreateGameLogAsync.fulfilled, (state) => {
      state.is_creating_gameLog = false
    })
    builder.addCase(CreateGameLogAsync.rejected, (state) => {
      state.is_creating_gameLog = false
    })
    builder.addCase(DeleteGameLogAsync.pending, (state) => {
      state.is_deleting_gameLog = true
    })
    builder.addCase(DeleteGameLogAsync.fulfilled, (state, action) => {
      state.is_deleting_gameLog = false
      if (state.gameLog) {
        state.gameLog = state.gameLog.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteGameLogAsync.rejected, (state) => {
      state.is_deleting_gameLog = false
    })
  },
})

export const {
  clearStategameLog,
  setSelectedgameLog,
  set_gameLog,
  mergegameLog,
  add_gameLog,
} = gameLogSlice.actions

export const get_gameLog =
  (id?: string) =>
  (state: {
    gameLog: {
      gameLog: GameLog[]
    }
  }): GameLog | null => {
    let temp = state?.gameLog?.gameLog?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.gameLog?.gameLog[0] || null
  }
export const get_selected_gameLog = (state: {
  gameLog: gameLogSliceState
}): GameLog | null => {
  let id = state?.gameLog?.selected_gameLog
  let temp = state?.gameLog?.gameLog?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_gameLog = (state: {
  gameLog: {
    gameLog: GameLog[]
  }
}): GameLog[] => {
  let temp = state?.gameLog?.gameLog
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_gameLog_busy = (state: { gameLog: gameLogSliceState }) => {
  return (
    state?.gameLog.is_deleting_gameLog ||
    state?.gameLog.is_loading_gameLog ||
    state?.gameLog.is_creating_gameLog
  )
}
export const is_deleting_gameLog_busy = (state: {
  gameLog: gameLogSliceState
}) => {
  return state?.gameLog.is_deleting_gameLog
}
export const is_loading_gameLog_busy = (state: {
  gameLog: gameLogSliceState
}) => {
  return state?.gameLog.is_loading_gameLog
}
export const is_creating_gameLog_busy = (state: {
  gameLog: gameLogSliceState
}) => {
  return state?.gameLog.is_creating_gameLog
}

export default gameLogSlice.reducer
